/* mobile-form-relocate.js — Round 16 (2026-05-03)
   Mobile-only: move the PDP contact form (.product-overview_block-right)
   to sit AFTER the related/complementary carousels, before the next
   discovery section. Desktop layout unchanged.

   Bidirectional via matchMedia listener: handles initial render +
   DevTools resize + orientation pivot.

   Fallback chain for insertion target (in priority order):
     1. After related_carousel_pdp shopify-section
     2. After complementary_carousel_pdp shopify-section
     3. Before featured_products shopify-section
     4. No move (form stays put)

   Single DOM element — no duplicate IDs, no form state loss.

   R16.1 (2026-05-03 17:42): adds horizontal padding when in relocated
   state. When the form moves out of .product-overview_row, it loses the
   parent's .padding-global chrome and renders edge-to-edge. We toggle
   `.is-mobile-relocated` on the form and inject a CSS rule that gives
   it 1.25rem horizontal padding (standard .padding-global mobile value)
   only while the class is present.
*/
(function () {
  'use strict';

  var BREAKPOINT = '(max-width: 768px)';
  var FORM_SELECTOR = '.product-overview_block-right';
  var RELOCATED_CLASS = 'is-mobile-relocated';
  var INSERT_AFTER_FALLBACKS = [
    '[id*="related_carousel_pdp"]',
    '[id*="complementary_carousel_pdp"]'
  ];
  var INSERT_BEFORE_FALLBACK = '[id*="featured_products"]';

  var formEl, originalParent, originalNextSibling;
  var moved = false;

  function injectStyles() {
    if (document.getElementById('mobile-form-relocate-styles')) return;
    var style = document.createElement('style');
    style.id = 'mobile-form-relocate-styles';
    style.textContent = [
      '.product-overview_block-right.' + RELOCATED_CLASS + ' {',
      '  padding-left: 1.25rem;',
      '  padding-right: 1.25rem;',
      '  box-sizing: border-box;',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function init() {
    formEl = document.querySelector(FORM_SELECTOR);
    if (!formEl) return;
    originalParent = formEl.parentNode;
    originalNextSibling = formEl.nextSibling;
    injectStyles();
    var mql = window.matchMedia(BREAKPOINT);
    apply(mql);
    if (mql.addEventListener) {
      mql.addEventListener('change', apply);
    } else if (mql.addListener) {
      mql.addListener(apply);
    }
  }

  function apply(mql) {
    if (mql.matches) {
      moveToMobilePosition();
    } else {
      restoreToOriginalPosition();
    }
  }

  function moveToMobilePosition() {
    if (moved) return;
    var targetEl = null;
    var insertMode = null;
    for (var i = 0; i < INSERT_AFTER_FALLBACKS.length; i++) {
      var el = document.querySelector(INSERT_AFTER_FALLBACKS[i]);
      if (el) { targetEl = el; insertMode = 'after'; break; }
    }
    if (!targetEl) {
      var fb = document.querySelector(INSERT_BEFORE_FALLBACK);
      if (fb) { targetEl = fb; insertMode = 'before'; }
    }
    if (!targetEl) return;
    if (insertMode === 'after') {
      targetEl.parentNode.insertBefore(formEl, targetEl.nextSibling);
    } else {
      targetEl.parentNode.insertBefore(formEl, targetEl);
    }
    formEl.classList.add(RELOCATED_CLASS);
    moved = true;
  }

  function restoreToOriginalPosition() {
    if (!moved) return;
    formEl.classList.remove(RELOCATED_CLASS);
    if (originalNextSibling && originalNextSibling.parentNode === originalParent) {
      originalParent.insertBefore(formEl, originalNextSibling);
    } else {
      originalParent.appendChild(formEl);
    }
    moved = false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
